/**
 * The correction categories `POST …/activity/{id}/feedback` accepts (activity-feed
 * `VALID_FEEDBACK_CATEGORIES`) — any other value is stored as null, so none is invented here.
 * Its own module, not services/api.ts: screens' tests mock that module wholesale, and a value
 * living there would vanish with it.
 */
export const FEEDBACK_CATEGORIES = ['tone', 'timing', 'channel', 'content', 'discount', 'other'] as const
export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number]
